Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  "default": 'default',
  email: 'email-address',
  number: 'numeric',
  username: 'email-address'
};